import ConfirmedHoldModal from './ConfirmedHoldModal';
import { canHoldConfirmed } from './confirmedHold';
import { CONFIRMED_HOLD_ENABLED } from '../../config/features';
import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect, useCallback } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, CountAmountLeft, TotalPayAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDateSplit, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum, convertDateFormat, datePickerCommonOpts, paintWeekendColors } from '../common/function';
import { getBrand } from '../../config/brand';
import { renderRevealAccountCell, useRevealAccounts } from './revealAccounts';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

function SettlementDeposits() {
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const MyData = useSelector((state) => state.MyData);
    const isBaekmaTestAdmin = getBrand().key === 'baekma' && MyData?.admin_id === 'test';
    const [holdRow, setHoldRow] = useState(null);
    const holdEnabled = CONFIRMED_HOLD_ENABLED;
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(30)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)
    const [retryLoadingIds, setRetryLoadingIds] = useState(new Set())
    const retryKeysRef = useRef(new Map())
    const listRequestRef = useRef(0);
    const { getRevealedAccount, isRevealLoading, revealAccount } = useRevealAccounts({
        enabled: isBaekmaTestAdmin,
        endpoint: '/api/payout/reveal-accounts',
    });

    const getAccountNumberDisplay = useCallback((data) => (
        isBaekmaTestAdmin ? (getRevealedAccount(data?.id)?.account_number || data?.account_number_masked) : data?.account_number
    ) || '', [isBaekmaTestAdmin, getRevealedAccount]);

    const getAccountHolderDisplay = useCallback((data) => (
        isBaekmaTestAdmin ? (getRevealedAccount(data?.id)?.account_holder || data?.account_holder_masked) : data?.account_holder
    ) || '', [isBaekmaTestAdmin, getRevealedAccount]);

    const genUUID = () => (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function")
        ? crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

    let tabList = ["익일", "즉결"]
    const [activeTab, setActiveTab] = useState("익일")

    useEffect(() => {
        dispatch(change_Current_Location("입금확정내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "거래조회",
            subTitle: "상세정보"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    // 기간 포맷 - 시작일/종료일 개별 선택
    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);

    useEffect(() => {
        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setPreDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endInputRef.current,
            setup: (picker) => {
                picker.on('render', paintWeekendColors);
                picker.on('selected', (date) => {
                    setPage(1)
                    setNextDate(date.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            startPickerRef.current?.destroy();
            endPickerRef.current?.destroy();
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수 (당일/전일/당월/전월 버튼에서 호출)
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        startPickerRef.current?.setDate(startDate);
        endPickerRef.current?.setDate(endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["전체", "가맹점", "지사", "총판", "대리점", "영업자1", "영업자2", "영업자3"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload, preDate, nextDate, activeTab])

    const ListData = async () => {
        const request = ++listRequestRef.current;
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/payout/confirm", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                type: activeTab == "익일" ? "daily" : "realtime",
                startDate: preDate,
                endDate: nextDate,
                searchType: selectedValue,
                keyword: (selectedText || "").trim().slice(0, 100),
            }
        }).then((response) => {
            if (request !== listRequestRef.current) return;
            let tmp = response?.data
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.payoutList ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.payoutList ?? []]);
                }
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            if (request === listRequestRef.current) setSpinner(false);
            console.error(error);
            // navigate("/");
        });
    }

    const handleRetry = async (id, name) => {
        if (!window.confirm(`"${name}" 건을 재처리 하시겠습니까?`)) return;

        // 같은 건 재시도 시 동일 UUID 재사용 (네트워크 에러/409 시 중복 이체 방지)
        const key = retryKeysRef.current.get(id) || genUUID();
        retryKeysRef.current.set(id, key);

        setRetryLoadingIds(prev => new Set(prev).add(id));
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/payout/retry",
                { id, idempotencyKey: key },
                {
                    withCredentials: true,
                    headers: { 'Idempotency-Key': key },
                    validateStatus: (s) => (s >= 200 && s < 300) || s === 409,
                }
            );

            if (response.status === 409) {
                alert("해당 건이 처리 중입니다. 잠시 후 다시 시도해주세요.");
                setPage(1);
                setReload(e => !e);
                return; // UUID 유지 → 재조회 시 동일 키 사용
            }

            const tmp = response?.data;
            if (tmp?.code === 1000) {
                const status = tmp?.data?.status;
                if (status === 'PENDING') {
                    alert("송금 확인 중입니다. 10분 내 최종 상태가 반영됩니다.");
                } else {
                    alert(tmp?.msg || "재이체 요청이 완료되었습니다.");
                }
                retryKeysRef.current.delete(id);
                setPage(1);
                setReload(e => !e);
            } else if (tmp?.code === 9999) {
                navigate('/');
            } else {
                const reason = (tmp?.data?.response?.result?.resultMsg || '').trim();
                alert(reason
                    ? `재처리에 실패했습니다.\n\n${reason}`
                    : (tmp?.msg || "재처리에 실패했습니다."));
                retryKeysRef.current.delete(id);
                setPage(1);
                setReload(e => !e);
            }
        } catch (error) {
            console.error(error);
            alert("재처리 요청 중 오류가 발생했습니다. 동일 버튼으로 재시도해주세요.");
            // UUID 유지 → 중복 이체 방지
        } finally {
            setRetryLoadingIds(prev => { const s = new Set(prev); s.delete(id); return s; });
        }
    };

    const tableHeaderData = [
        { "no": 1, "text": "정산일자", "width": "85px", "textAlign": "center" },
        { "no": 11, "text": "MID", "width": "60px", "textAlign": "center", "flex": 1 },
        { "no": 3, "text": "가맹점명", "width": "80px", "textAlign": "center", "flex": 1.5 },
        { "no": 4, "text": "정산액", "width": "65px", "textAlign": "center", "flex": 1 },
        { "no": 12, "text": "입금액", "width": "65px", "textAlign": "center", "flex": 1 },
        { "no": 5, "text": "예금주", "width": "60px", "textAlign": "center", "flex": 1 },
        { "no": 6, "text": "입금계좌", "width": "100px", "textAlign": "center", "flex": 1.5 },
        { "no": 7, "text": "은행", "width": "50px", "textAlign": "center", "flex": 0.8 },
        { "no": 8, "text": "결제타입", "width": "60px", "textAlign": "center", "flex": 0.8 },
        { "no": 13, "text": "지갑", "width": "45px", "textAlign": "center", "flex": 0.6 },
        { "no": 8, "text": "처리상태", "width": "60px", "textAlign": "center", "flex": 0.8 },
        { "no": 16, "text": "이체일시", "width": "120px", "textAlign": "center", "flex": 1 },
        { "no": 14, "text": "실패사유", "width": "120px", "textAlign": "center", "flex": 1.2 },
        { "no": 15, "text": holdEnabled ? "관리" : "재처리", "width": "70px", "textAlign": "center", "flex": 0.7 },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            let list = (listTrxData ?? []).filter(d => d.status !== "보류" && d.transfer_status !== "보류");
            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                let trxDateStr = (data.trx_date || '').split(' ')[0];
                let displayDate = activeTab === "익일" ? dayjs(trxDateStr).add(1, 'day').format('YYYY-MM-DD') : trxDateStr;

                tableBodyData.push([
                    { no: 1, text: displayDate, width: "85px", textAlign: "center" },
                    { no: 11, text: data.user_id || '', width: "60px", textAlign: "center", flex: 1 },
                    { no: 3, text: data.co_nm, width: "80px", textAlign: "left", flex: 1.5 },
                    { no: 4, text: changeNum(data.requested_amount), width: "65px", textAlign: "right", flex: 1 },
                    { no: 12, text: changeNum(data.final_amount), width: "65px", textAlign: "right", flex: 1 },
                    { no: 6, text: getAccountHolderDisplay(data), width: "60px", textAlign: "center", flex: 1 },
                    {
                        no: 7,
                        text: renderRevealAccountCell({
                            enabled: isBaekmaTestAdmin,
                            id: data.id,
                            value: getAccountNumberDisplay(data),
                            revealed: !!getRevealedAccount(data.id),
                            loading: isRevealLoading(data.id),
                            onReveal: revealAccount,
                        }),
                        width: "100px",
                        textAlign: "center",
                        flex: 1.5
                    },
                    { no: 8, text: data.bank_name, width: "50px", textAlign: "center", flex: 0.8 },
                    { no: 9, text: data.payment_type || '-', width: "60px", textAlign: "center", flex: 0.8 },
                    { no: 13, text: data.merchant_deposit_yn ?? "-", width: "45px", textAlign: "center", flex: 0.6,
                        style: { color: data.merchant_deposit_yn === "예치" ? "#2563eb" : "#999" }
                    },
                    {
                        no: 9, text: (
                            data.transfer_status == "송금 완료"
                                ?
                                <div style={{ color: "green", fontWeight: "bold" }}>
                                    {data.transfer_status}
                                </div>
                                :
                                data.transfer_status == "송금 실패"
                                    ?
                                    <div style={{ color: "red", fontWeight: "bold" }}>
                                        {data.transfer_status}
                                    </div>
                                    :
                                    <div style={{ color: "gray", fontWeight: "bold" }}>
                                        {data.transfer_status}
                                    </div>
                        ), width: "60px", textAlign: "center", flex: 0.8
                    },
                    { no: 16, text: data.transfer_at ? dayjs.utc(data.transfer_at).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss') : '-', width: "120px", textAlign: "center", flex: 1 },
                    {
                        no: 14,
                        text: data.transfer_status === "송금 실패"
                            ? (data.transfer_fail_reason || data.transfer_result_msg || "-")
                            : "-",
                        width: "120px", textAlign: "center", flex: 1.2,
                        style: data.transfer_status === "송금 실패" ? { color: "red" } : {}
                    },
                    {
                        no: 15,
                        text: canHoldConfirmed(data, { enabled: holdEnabled, role: MyData?.role, tab: activeTab })
                            ? <button type="button" onClick={() => setHoldRow(data)} style={{ padding: '4px 8px', color: '#92400e', border: '1px solid #d97706', borderRadius: 4 }}>보류</button>
                            : data.transfer_status === "송금 실패"
                            ? (
                                <button
                                    onClick={() => handleRetry(data.id, data.co_nm)}
                                    disabled={retryLoadingIds.has(data.id)}
                                    style={{
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        borderRadius: "4px",
                                        border: "1px solid #f59e0b",
                                        backgroundColor: retryLoadingIds.has(data.id) ? "#e5e7eb" : "#fbbf24",
                                        color: retryLoadingIds.has(data.id) ? "#9ca3af" : "#92400e",
                                        cursor: retryLoadingIds.has(data.id) ? "not-allowed" : "pointer",
                                        fontWeight: "bold"
                                    }}
                                >
                                    재처리
                                </button>
                            )
                            : "",
                        width: "70px", textAlign: "center", flex: 0.7
                    },
                ]);
            }
            setCombineData(tableBodyData);
        }
    }, [listTrxData, activeTab, holdEnabled, MyData?.role, retryLoadingIds, getAccountHolderDisplay, getAccountNumberDisplay, getRevealedAccount, isRevealLoading, revealAccount, isBaekmaTestAdmin]); // ✅ checkedIds 추가

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
        setPage(1);
    };

    const excelBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/payout/confirm/excel", {
            withCredentials: true,
            params: {
                startDate: preDate,
                endDate: nextDate,
                type: activeTab === "익일" ? "daily" : "realtime",
                searchType: selectedValue,
                keyword: (selectedText || "").trim().slice(0, 100),
            },
        }).then((response) => {
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.payoutList ?? []);
            }
        }).catch((error) => {
            console.error(error);
        });
    };

    const excelData = (exData) => {
        const arr = [];
        if (exData && exData.length > 0) {
            for (let i = 0; i < exData.length; i++) {
                const t = exData[i];
                const datePart = t.requested_at ? t.requested_at.split(" ")[0] : "";
                arr.push({
                    정산일자: datePart,
                    MID: t.user_id ?? "",
                    가맹점명: t.co_nm ?? "",
                    정산액: t.requested_amount ?? "",
                    "입금액": t.final_amount ?? "",
                    예금주: getAccountHolderDisplay(t),
                    입금계좌: getAccountNumberDisplay(t),
                    은행: t.bank_name ?? "",
                    결제타입: t.payment_type ?? "",
                    지갑: t.merchant_deposit_yn ?? "-",
                    처리상태: t.transfer_status ?? "",
                    실패사유: t.transfer_fail_reason || t.transfer_result_msg || "",
                });
            }
        }
        Excel(arr);
    };

    return (
        <div className="content" id="contents">
            {holdRow && <ConfirmedHoldModal row={holdRow} onClose={() => setHoldRow(null)} onRefresh={() => {
                ++listRequestRef.current;
                setListTrxData([]);
                setPage(1);
                setReload(value => !value);
            }} />}
            {loading ? <LoadingModal /> : ""}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDateSplit
                        startInputRef={startInputRef}
                        endInputRef={endInputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={false}
                        state={true}
                    />

                    {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} />}
                </form>
            </div>

            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleClickTab(tab)}
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "14px",
                                    fontWeight: activeTab === tab ? "600" : "400",
                                    color: activeTab === tab ? "#222" : "#888",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom: activeTab === tab ? "3px solid #3182F6" : "3px solid transparent",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer"
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    <div className='excel-disable' style={{ width: "auto" }}>
                        <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />
                        <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                    </div>
                </div>
                <div style={{ width: "100%"}}>
                    <List
                        tableHeaderData={tableHeaderData}
                        tableBodyData={listData?.totCnt ?? 0}
                        filter_tableBodyData={combineData}
                        page={page}
                        setPage={setPage}
                        maxFirstPage={maxFirstPage}
                        observerRef={observerRef}
                        nonePage={false}
                        scrollState={true}
                        spinner={spinner}
                        height={"700px"}
                    />
                </div>
            </div>
        </div>
    );
}

const Excel = (excelData) => {
    const excelFileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const excelFileExtension = ".xlsx";
    const excelFileName = "입금확정 가맹점내역";

    const headerRow = ["정산일자", "MID", "가맹점명", "정산액", "입금액", "예금주", "입금계좌", "은행", "결제타입", "지갑", "처리상태", "실패사유"];
    const bodyRows = excelData.map((data) => ([
        data.정산일자,
        data.MID,
        data.가맹점명,
        Number(data.정산액) || data.정산액,
        Number(data["입금액"]) || data["입금액"],
        data.예금주,
        data.입금계좌,
        data.은행,
        data.결제타입,
        data.지갑,
        data.처리상태,
        data.실패사유,
    ]));
    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!cols"] = Array(headerRow.length).fill({ wpx: 100 });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default SettlementDeposits;
